import { useQuery } from "@apollo/client";
import { parseError } from "Apollo";
import Errors from "components/Errors";
import Spinner from "components/Spinner";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS } from "./graphql";
import SubmitDeliveryPage from "./SubmitDeliveryPage";

const SubmitDeliveryPageContainer = () => {
  const [searchParams] = useSearchParams();
  const sourceId = searchParams.get("sourceId");

  const { loading, error, data } = useQuery(FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS, {
    skip: !sourceId,
    variables: { ids: [sourceId] },
    fetchPolicy: "network-only",
    onCompleted(queryData) {
      const source = queryData.spSupplierStockUpdateRequests.results?.[0];
      if (!source) {
        toast.error("Cannot find source submit record. 无法找到重提来源记录。");
        return;
      }

      let parsed;
      try {
        parsed = JSON.parse(source.data);
      } catch (queryError) {
        toast.error("Invalid source data. 源数据格式异常。");
        return;
      }
      if (!Array.isArray(parsed?.products)) {
        toast.error("Invalid source data. 源数据格式异常。");
      }
    },
    onError(queryError) {
      toast.error(parseError(queryError));
    },
  });

  if (loading && sourceId) return <Spinner />;
  if (error) return <Errors error={error} />;

  const source = data?.spSupplierStockUpdateRequests?.results?.[0];
  const products = data?.supplierStockProducts || [];
  const productsById = products.reduce((acc, product) => {
    acc[product.id] = product;
    return acc;
  }, {});

  let parsedSourceData = null;
  if (source?.data) {
    try {
      parsedSourceData = JSON.parse(source.data);
    } catch (queryError) {
      parsedSourceData = null;
    }
  }

  const initialDeliveries = Array.isArray(parsedSourceData?.products)
    ? parsedSourceData.products
        .map((sourceProduct) => {
          const product = productsById[sourceProduct.id];
          if (!product) return null;
          return {
            product,
            qty: sourceProduct.qty ?? 0,
            date: sourceProduct.readyDate
              ? moment(sourceProduct.readyDate).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
            remark: sourceProduct.remark || "",
          };
        })
        .filter(Boolean)
    : [];

  return <SubmitDeliveryPage initialDeliveries={initialDeliveries} />;
};

export default SubmitDeliveryPageContainer;
